
define('eteration/ui/form-viewmodel',['jquery',
        'knockout',
        'eteration/ui/base-viewmodel',
        'moment',
        'eteration/eteration-i18n',
        'eteration/widgets/ui-form-items',
        'eteration/ui/ko-validation',
		'jquery.inputmask.min',],
	function($,ko,BaseViewModel,moment,i18n) {		
							
				function FormViewModel() {
					var self = this;
					
					ko.utils.extend(self, new BaseViewModel.BaseViewModel());	
					
					self.validationContext = ko.jqValidation({
						postValidators:[]
					});

					self.validationPropertyResolver = function(validationProperties,id){

						if (!id) {
							return {};
						}
						
						for (var propertyIndex = 0; propertyIndex < validationProperties.length; propertyIndex++) {
							if(validationProperties[propertyIndex].id == id){
								return validationProperties[propertyIndex];
							}
						}

						return {};
						
				    };
					
		            self.updateValidationContext = function(contextId,context){
		                setTimeout(function(){
		                    ko.bindingHandlers.jqValidation.update($(contextId), context);
		                }, 1000);
		            };
					
					self.textNone = ko.observable(i18n.get('text.none'));
					self.language =  ko.observable(i18n.getUserLocale());

					self.changeLoyaltyProgram = function(index, loyaltyProgramID) {
						if(loyaltyProgramID() === 'TK') {
							$('#flyernumber_' + index).inputmask({ mask: "999999999"});
						} else {
							$('#flyernumber_' + index).inputmask('remove');
						}
					}

				}

				return { FormViewModel:FormViewModel};

});
	